import React from "react";
import { Col, Row } from "components/bootstrap";
import SharedCollectionsList from "./SharedCollectionsList/SharedCollectionsList";
const TeamCollections = ({ teamId }) => /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(SharedCollectionsList, { id: teamId, filterBy: "team" })));
export default TeamCollections;
